import styles from './index.module.scss'

export function Loader({ isBig = false }) {
  return <span className={`${styles.loader} ${isBig ? styles.big : ''}`} />
}
